import {apiResponse, Nullable} from "@/lib/types";
import {getSession} from "@/lib/auth";

const apiUploadMedia = async (formData: FormData) : Promise<apiResponse> => {
    const token = await getSession(`${process.env.COOKIE_PREFIX}-token`);
    return await fetch(`${process.env.NEXT_PUBLIC_API_BASE}media/upload`,
        {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
            },
            body:formData
        }).then(r => r.json()) as apiResponse;
}

const apiUploadMultipleMedia = async (formData: FormData) : Promise<apiResponse> => {
    const token = await getSession(`${process.env.COOKIE_PREFIX}-token`);
    return await fetch(`${process.env.NEXT_PUBLIC_API_BASE}media/upload/group`,
        {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData,
            redirect: "follow"
        }).then(r => r.json()) as apiResponse;
}

const apiGetToken = async (values:any) : Promise<apiResponse> => {
    return await fetch(`${process.env.NEXT_PUBLIC_API_BASE}auth/login`,
        {
            method: "POST",
            body: JSON.stringify(values),
            headers: {
                "Content-Type": "application/json"
            },
            redirect: "follow"
        }).then(r => r.json()) as apiResponse;
}

const apiGetProfile = async () : Promise<apiResponse> => {
    const tokenData = await getSession(`${process.env.COOKIE_PREFIX}-token`);
    return await fetch(`${process.env.NEXT_PUBLIC_API_BASE}auth/me`,
        {
            method: "POST",
            headers: {
                Authorization: `Bearer ${tokenData.data}`
            },
            redirect: "follow"
        }).then(r => r.json()) as apiResponse;
}

const apiSiteActive = async (domain:string) : Promise<{status: Nullable<boolean>;type: Nullable<number>}> => {
    const params = new URLSearchParams();
    params.append('domain', domain);

    return await fetch(`http://127.0.0.1:5000/tenant/base/is-activate?${params.toString() || ''}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
            redirect: "follow"
        }).then(r => r.json()) as {status: Nullable<boolean>;type: Nullable<number>};
}

const apiFilters = async (
    route_name: string,
    parameters: Partial<any> | {},
    page: number | null,
    limit: number | null,
    order_by: string[] | null
): Promise<apiResponse> => {
    const tokenData = await getSession(`${process.env.COOKIE_PREFIX}-token`);

    let params: { [key: string]: any } = {};

    if(page != null && limit != null) {
        params["page"] = page;
        params["limit"] = limit;
    }
    if(order_by && order_by.length > 0){
        params['order_by'] = order_by
    }
    if (parameters != null) {
        for (const [key, value] of Object.entries(parameters)) {
            if (value !== null && value !== '' && value !== undefined && value !== 'undefined') {
                if (Array.isArray(value)) {
                    const validOrderBy = value.filter((item) =>
                        item &&
                        typeof item === 'object' &&
                        typeof item.field === 'string' &&
                        (item.direction === 'asc' || item.direction === 'desc')
                    );
                    if (validOrderBy.length > 0) {
                        params[key] = validOrderBy;
                    }
                }else{
                    params[key] = value;
                }
            }
        }
    }

    return await fetch(`${process.env.NEXT_PUBLIC_API_BASE}${route_name}/filters`,
        {
            method: "POST",
            headers: {
                Authorization: `Bearer ${tokenData.data}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params),
            redirect: "follow"
        }).then(r => r.json()) as apiResponse;

}
export {apiUploadMultipleMedia, apiUploadMedia, apiGetToken, apiGetProfile, apiSiteActive, apiFilters}